import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {defineCustomElements} from '@ionic/pwa-elements/loader';
import {initializeApp} from 'firebase/app';
import {getAnalytics} from 'firebase/analytics';

if (environment.production) {
  const firebaseConfig = {
    apiKey: 'AIzaSyARP27P9Nuy3hruGgXqxjmm5ENEV88YJi4',
    authDomain: 'simo-webapp.firebaseapp.com',
    projectId: 'simo-webapp',
    storageBucket: 'simo-webapp.appspot.com',
    messagingSenderId: '942367409361',
    appId: '1:942367409361:web:72a2a7d83539b08e34b1f0',
    measurementId: 'G-N330QKB6CY'
  };

  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);

  enableProdMode();
} else if ('serviceWorker' in navigator) {
  // A worker left behind by a production build can serve stale lazy chunks
  // while developing, briefly producing a 404 before the dev server reloads.
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });

  if ('caches' in window) {
    caches.keys().then((cacheNames) => {
      cacheNames
        .filter((cacheName) => cacheName.startsWith('ngsw:'))
        .forEach((cacheName) => caches.delete(cacheName));
    });
  }
}




platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));

defineCustomElements(window);
